import { render, staticRenderFns } from "./buildOvertime.vue?vue&type=template&id=2030f80e&scoped=true&"
import script from "./buildOvertime.vue?vue&type=script&lang=js&"
export * from "./buildOvertime.vue?vue&type=script&lang=js&"
import style0 from "./buildOvertime.vue?vue&type=style&index=0&id=2030f80e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2030f80e",
  null
  
)

export default component.exports